
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/view-order-history",
      function () {
        return require("private-next-pages/shopping/view-order-history.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shopping/view-order-history"])
      });
    }
  